module.exports = __webpack_public_path__ + "media/images/page/photo_s2-c27a59e4885d32f0bc9782c7e44fe323.jpg";